function initImpactCTAViewers() {
  document.querySelectorAll(".impact-cta__viewer[data-video-id]").forEach(function (el, idx) {
    if (el.dataset.initialized === "true") return;

    var videoId = el.getAttribute("data-video-id");
    if (!videoId) return;

    var containerId = "s7viewer-" + idx;
    el.id = containerId;
    el.dataset.initialized = "true";

    var viewer = new s7viewers.VideoViewer({
      containerId: containerId,
      params: {
        asset: videoId,
        config: "bhsf/Video",
        serverurl: "https://s7d9.scene7.com/is/image/",
        contenturl: "https://s7d9.scene7.com/is/content/",
        videoserverurl: "https://s7d9.scene7.com/is/content",
        loop: "1",
        mute: "1",
        controls: "none"
      },
      handlers: {
        initComplete: function () {
          var player = viewer.videoplayer;
          if (player) {
            player.mute();
          }
          
          var controls = el.querySelector(".s7controlbar");
          if (controls) {
            controls.style.display = "none";
          }

          const videoContainer = el.closest('.impact-cta--video');
          const imageFade = videoContainer.querySelector('.impact-cta__image');
          // Event listeners for mouse enter and leave
          videoContainer.addEventListener('mouseenter', () => {
            if (window.innerWidth > 599) {
              imageFade.style.opacity = 0; // Fade out the image
            }
            player.play(); // Play video on mouse enter
          });

          videoContainer.addEventListener('mouseleave', () => {
            imageFade.style.opacity = 1; // Fade in the image
            player.pause(); // Pause video on mouse leave
          });
        }
      }
    });

    viewer.init();
    el.viewer = viewer;
  });
}

document.addEventListener("DOMContentLoaded", function () {
  if (document.querySelector(".impact-cta__viewer[data-video-id]")) {
    Scene7Loader.load(initImpactCTAViewers);
  }
});
